/**
 * Sort events by start date (ascending; no date → end of list), then alphabetically by name.
 */
export function sortEventsByStartDateThenName<T extends { startDate?: string | number | null; name?: string | null }>(events: T[]): T[] {
    return [...events].sort((a, b) => {
        const aTime = a.startDate != null && a.startDate !== '' ? new Date(a.startDate).getTime() : Infinity;
        const bTime = b.startDate != null && b.startDate !== '' ? new Date(b.startDate).getTime() : Infinity;
        if (aTime !== bTime) return aTime - bTime;
        const aName = (a.name ?? '').toLowerCase();
        const bName = (b.name ?? '').toLowerCase();
        return aName.localeCompare(bName);
    });
}
